import { ref, watch } from 'vue'

const theme = ref(localStorage.getItem('theme') ?? 'light')

document.documentElement.setAttribute('data-bs-theme', theme.value)

watch(theme, (value) => {
	localStorage.setItem('theme', value)
	document.documentElement.setAttribute('data-bs-theme', value)
})

export function useTheme() {
	return { theme }
}
